"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

var isExpectedAxiosError = function isExpectedAxiosError(error, validationRule) {
  try {
    if (_axios["default"].isAxiosError(error) && error.code == validationRule) {
      return true;
    }
  } catch (error) {
    return false;
  }

  return false;
};

var _default = isExpectedAxiosError;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9VdGlscy9pc0V4cGVjdGVkQXhpb3NFcnJvci50cyJdLCJuYW1lcyI6WyJpc0V4cGVjdGVkQXhpb3NFcnJvciIsImVycm9yIiwidmFsaWRhdGlvblJ1bGUiLCJheGlvcyIsImlzQXhpb3NFcnJvciIsImNvZGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztBQUVBLElBQU1BLG9CQUFvQixHQUFHLFNBQXZCQSxvQkFBdUIsQ0FBQ0MsS0FBRCxFQUE4QkMsY0FBOUIsRUFBa0U7QUFDM0YsTUFBSTtBQUNBLFFBQUlDLGtCQUFNQyxZQUFOLENBQW1CSCxLQUFuQixLQUE2QkEsS0FBSyxDQUFDSSxJQUFOLElBQWNILGNBQS9DLEVBQStEO0FBQzNELGFBQU8sSUFBUDtBQUNIO0FBQ0osR0FKRCxDQUlFLE9BQU9ELEtBQVAsRUFBYztBQUNaLFdBQU8sS0FBUDtBQUNIOztBQUVELFNBQU8sS0FBUDtBQUNILENBVkQ7O2VBWWVELG9CIiwic291cmNlUm9vdCI6Im9jc2RrOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBheGlvcywgeyBBeGlvc0Vycm9yIH0gZnJvbSBcImF4aW9zXCI7XG5cbmNvbnN0IGlzRXhwZWN0ZWRBeGlvc0Vycm9yID0gKGVycm9yOiB1bmtub3duIHwgQXhpb3NFcnJvciwgdmFsaWRhdGlvblJ1bGU6IHN0cmluZyk6IGJvb2xlYW4gPT4ge1xuICAgIHRyeSB7XG4gICAgICAgIGlmIChheGlvcy5pc0F4aW9zRXJyb3IoZXJyb3IpICYmIGVycm9yLmNvZGUgPT0gdmFsaWRhdGlvblJ1bGUpIHtcbiAgICAgICAgICAgIHJldHVybiB0cnVlO1xuICAgICAgICB9XG4gICAgfSBjYXRjaCAoZXJyb3IpIHtcbiAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgIH1cblxuICAgIHJldHVybiBmYWxzZTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGlzRXhwZWN0ZWRBeGlvc0Vycm9yOyJdfQ==